/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ProductDeliveryOptions } from '@msdyn365-commerce/retail-proxy';
import { getSelectedProductIdFromActionInput } from '../themes/dobbies/actions/utilities/rating-utils';
import { getSelectedVariantAction, SelectedVariantInput } from '../themes/dobbies/actions/get-selected-variant.override.action';
import { getDeliveryOptionsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

/**
 * GetBuyboxDeliveryOptions Input Action
 */
export class GetBuyboxDeliveryOptionsInput implements Msdyn365.IActionInput {
    public productId: number;
    // TODO: Construct the input needed to run the action
    constructor(productId: number) {
        this.productId = productId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `BUYBOX_DELIVERY_OPTIONS_${this.productId}`;
    public getCacheObjectType = () => 'BUYBOX_DELIVERY_OPTIONS';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetBuyboxDeliveryOptionsData {
    deliveryOptions: ProductDeliveryOptions[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(args);
    if (productId) {
        return new GetBuyboxDeliveryOptionsInput(+productId);
    } else {
        throw new Error('Unable to create GetBuyboxDeliveryOptionsInput, no productId found');
    }
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetBuyboxDeliveryOptionsInput, ctx: Msdyn365.IActionContext): Promise<IGetBuyboxDeliveryOptionsData> {
    const selectedVariantInput = new SelectedVariantInput(input.productId, ctx.requestContext.apiSettings.channelId);
    try {
        const product = await getSelectedVariantAction(selectedVariantInput, ctx);
        const deliveryOptions = await getDeliveryOptionsAsync({ callerContext: ctx, queryResultSettings: {} }, [product?.RecordId || 0]);

        return { deliveryOptions: deliveryOptions || [] };
    } catch (error) {
        if (error instanceof Error) {
            ctx.telemetry.error(`Error in GetBuyboxDeliveryOptions action: ${error.message}`);
        }
        return { deliveryOptions: [] };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetBuyboxDeliveryOptionsData>>action,
    // TODO: Give your data action a unique id
    id: 'GetBuyboxDeliveryOptions',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
